// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"style_tableWrapper__PE5hF","tableTitle":"style_tableTitle__3tSVt"};